'use es6';

import I18n from 'I18n';
export default (function () {
  return I18n.locale;
});